import { FC } from 'react';

import { StyledPill } from './Pill.styles';
import { PillProps } from './Pill.types';

const Pill: FC<PillProps> = ({ id, label, selected, onClick }) => {
  const handleClick = (id: string): void => {
    onClick?.(id);
  };

  return (
    <StyledPill data-testid={`pill-${id}`} role={'pill'} selected={selected} onClick={() => handleClick(id)}>
      {label}
    </StyledPill>
  );
};

export default Pill;
